import { z } from 'zod';
import {
  moneyOutSchema,
  optionalMoney,
  optionalNumber,
  optionalText,
  requiredText,
  versionField,
} from './fields';
import { idSchema } from './ids';

/** Team member / resource (FR-RES-002). */
export const resourceInputSchema = z.object({
  name: requiredText(200, 'Vārds ir obligāts'),
  role: requiredText(200, 'Loma ir obligāta'),
  /** Hours per week, whole number. */
  availability: optionalNumber({ min: 0, max: 168, int: true }),
  /** €/h — finance data: only visible and editable with `finance.view` (FR-WS-006). */
  hourlyRate: optionalMoney,
  competences: optionalText(2000),
  jiraAccountId: optionalText(200),
});
export type ResourceInput = z.input<typeof resourceInputSchema>;

export const resourceUpdateSchema = resourceInputSchema.extend(versionField);

export const resourceSchema = z.object({
  id: idSchema,
  name: z.string(),
  role: z.string(),
  availability: z.number().nullable(),
  /** `null` also when the caller may not see finance data. */
  hourlyRate: moneyOutSchema,
  competences: z.string().nullable(),
  jiraAccountId: z.string().nullable(),
  version: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Resource = z.infer<typeof resourceSchema>;
